import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { init as jsBridgeInit } from '@haidilao-private/jsbridge';
import Vconsole from 'vconsole';
import pathConfig from '@/utils/pathConfig';
jsBridgeInit();

// 非线上环境添加vconsole
if (pathConfig.IS_SHOW_VCONSOLE) {
  const vconsole = new Vconsole();
  console.log(vconsole);
}

const root = document.getElementById('root') as HTMLElement;

ReactDOM.createRoot(root).render(
  <Provider store={store}>
    <StrictMode>
      <App />
    </StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
